import {Environment} from './environment.interface';
import {prodEnv} from './environment.prod';

export const prodEnEnv: Environment = prodEnv;
